'use client';

import { Typography } from '@mui/material';
import { stripCommaGroups } from '../utils/currencyUtils';
import { CalculatorField } from './CalculatorField';
import { CalculatorOutlinedInput } from './CalculatorOutlinedInput';

const DOLLAR_ADORNMENT = (
  <Typography variant="text" sx={{ color: 'neutral.main', fontWeight: 325 }}>
    $
  </Typography>
);

export type CurrencyCalculatorInputProps = {
  error?: string | null;
  fullWidth?: boolean;
  id: string;
  label: string;
  onBlur?: () => void;
  onValidRawChange: (raw: string) => void;
  pattern: RegExp;
  value: string;
};

/**
 * Dollar-prefixed decimal field with shared calculator styling and validation.
 */
export function CurrencyCalculatorInput({
  error,
  fullWidth = true,
  id,
  label,
  onBlur,
  onValidRawChange,
  pattern,
  value,
}: CurrencyCalculatorInputProps) {
  const hasError = Boolean(error);

  return (
    <CalculatorField error={error} htmlFor={id} label={label}>
      <CalculatorOutlinedInput
        id={id}
        fullWidth={fullWidth}
        hasError={hasError}
        slotProps={{
          input: {
            inputMode: 'decimal',
            sx: { padding: 0 },
          },
        }}
        startAdornment={DOLLAR_ADORNMENT}
        value={value}
        onBlur={onBlur}
        onChange={e => {
          const raw = stripCommaGroups(e.target.value);
          if (!pattern.test(raw)) {
            return;
          }
          onValidRawChange(raw);
        }}
      />
    </CalculatorField>
  );
}
